<!--
 * @Description:服务导入组件
 * @Author:sunhuihong
 * @Date: 2022-05-31 10:57:42
 * @LastEditTime: 2022-05-31 17:46:31
-->
<template>
  <el-dialog width="80%" :title="dialogTitle" :visible.sync="showHserviceImportDialog" :close-on-click-modal="false"
    :before-close="handleCancel"  @open="initData" center append-to-body>
    <el-row style="padding: 0px 30px 25px 30px;"  type="flex" justify="space-between" >
      <el-col :span="7">
        <span class="search-title">所属机构:</span>
        <el-select style="width:190px" size="small" v-model="filterParams.instiutionId " clearable filterable    
          placeholder="请选择机构"  
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionsList', srcInstitutionsList, this))"
					@visible-change="(visible) => 
            commonUtil.handleListFilterVisibleChange(visible, 'institutionsList', srcInstitutionsList, this)">
          <el-option v-for="item in institutionsList"  :key="item.id"   :label="item.name"  :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="7" >
        <span class="search-title">服务名称:</span>
        <el-input size="small" style="width: 190px;"  v-model="filterParams.hserviceCfgName" placeholder="请输入服务名称">
        </el-input>
      </el-col>
      <el-col :span="7" >
        <span class="search-title">服务类型:</span>
        <el-select size="small" style="width: 180px" v-model="filterParams.hserviceTypeCfgId"  placeholder="请选择服务类型" >
          <el-option v-for="item in hserviceTypeCfgList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" style="text-align: right">
        <el-button size="small" @click="handleQuery"  type="primary" icon="el-icon-search">搜 索</el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div> 
    <div style="padding: 20px 30px;">
      <el-table style="border: 1px solid #f0f0f0;" :header-cell-style="{ 'text-align': 'left', 'background-color': '#EFF5FA'}" 
        max-height="400px" ref="hserviceListTable" :data="dataTable" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="服务名称" min-width="25%" align="left"></el-table-column>
        <el-table-column prop="hserviceTypeCfgText" label="服务类型"   min-width="25%" align="left"></el-table-column>
        <el-table-column prop="lowPriceYuan" label="服务价格" min-width="25%" align="left" sortable
          :sort-method="(a,b)=>{return a.lowPriceYuan - b.lowPriceYuan}">
        </el-table-column>
        <el-table-column prop="categoryText" label="服务类别" min-width="25%" align="left"></el-table-column>          
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancelSelect">取 消</el-button>
      <el-button type="primary" @click="handleImportHserviceList">确定导入</el-button>
    </span>
  </el-dialog>   
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
    name: 'HserviceImport',
    props: ["showHserviceImportDialog", "instiutionId"],
    data() {
      return {
        dialogTitle: '系统导入' ,
        dataTable: [],
        filterParams: {
          instiutionId: '',
        },
        institutionsList: [],
        srcInstitutionsList: [],
        categoryMap: [],
        hserviceItemIdList: [],//table表格选中得数据id集合，用于传递给后端
        hserviceTypeCfgList: [],
      }
    },
    
    methods: {
      async initData() {
        await this.getFilterDo();
        await this.listHservice();
      },

      //查询过滤条件
      getFilterDo() {
        return new Promise((resolve) => {
          this.appAxios("GET", Constant.URL_GET_IMPORT_HSERVICE_CFG_FILTER_DO).then(result => {
            if (result != null) {
            this.institutionsList = result.data.institutionList;
            this.srcInstitutionsList = result.data.institutionList;
            this.hserviceTypeCfgList = result.data.hserviceTypeCfgList;
            this.filterParams.instiutionId = this.instiutionId;
            resolve();
            }
          })
        })
      },

      //获取table表格数据
      listHservice() {
        return new Promise((resolve) => {
          let header = this.encryptionUtil.signatureParams(this.filterParams,
            Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
          let requestData = {
            method: 'GET',
            url: Constant.URL_GET_IMPORT_HSERVICE_CFG_LIST,
            param: this.filterParams,
            header: header,
            contentType: this.commonConst.CNTYPE_URLENCODED,
          };

          this.vueRequest(requestData).then(result => {
            if (result != null) {
              this.dataTable = result.data;
              resolve();
            }
          })
        })
      },

      //根据过滤条件搜索指定数据
      handleQuery() {
        this.listHservice();
      },
      
      //当table表格选择项发生变化时触发该事件，得到选中得数据，格式[{},{}]
      handleSelectionChange(data) {
        this.hserviceItemIdList = data.map((item) => {return item.id;});
      },

      //取消选中得table表格数据
      handleCancelSelect() {
        this.$refs.hserviceListTable.clearSelection();
        this.clearData();
        this.$emit("close-hservice-import", false);  
      },

      //确认导入服务项目
      handleImportHserviceList() {
        this.saveImportHserviceCfgsFormData();
      },

      saveImportHserviceCfgsFormData() {
        let instiutionId = this.filterParams.instiutionId;
        let hserviceCfgIdList = this.hserviceItemIdList;
        if (hserviceCfgIdList.length == 0) {
          this.$message.error( "请选择需要导入的服务项目！")
          return false;
        }
        let params = {
          instiutionId: instiutionId,
          hserviceCfgIdList: hserviceCfgIdList
        };
        let header = this.encryptionUtil.signatureBody(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'POST',
          url: Constant.URL_SAVE_IMPORT_HSERVICES_FORM_CFG,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };
        this.vueRequest(requestData).then((result) => {
          if (result != null) {
            this.$refs.hserviceListTable.clearSelection();
            this.$emit('save-import-hservice', this.filterParams.instiutionId);
            this.clearData();
          }
        });
      },

      clearData() {
        this.filterParams = {};
      },

      handleCancel() {
        this.clearData();
        this.$emit('close-hservice-import', false);
      },
    },
  }
</script>
<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
  display: inline-block;
  text-align: right;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}
</style>


// WEBPACK FOOTER //
// src/components/hsvcmng/components/HserviceImport.vue